import { render } from "./App.vue?vue&type=template&id=39e0176e&scoped=true"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"

import "./App.vue?vue&type=style&index=0&id=39e0176e&lang=css"
import "./App.vue?vue&type=style&index=1&id=39e0176e&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-39e0176e"

export default script